import styled from "@emotion/styled";
import mintingSoonSrc from "assets/images/minting-soon.svg";
import { Columns, Text } from "atoms";
import { ReviewableCard } from "features/reviewable";
import { useReviewableList } from "features/search";
import { ViewAllLink } from "./ViewAllLink";

function MintingSoon() {
  const { data: mintingSoon } = useReviewableList("minting-soon");

  return (
    <>
      <Header>
        <img src={mintingSoonSrc} alt="Minting Soon" />

        <div>
          <Subtitle>Check out our favs and save the date!</Subtitle>
          <ViewAllLink to="/search?mintStatus=not+yet+minted">
            View All
          </ViewAllLink>
        </div>
      </Header>

      {mintingSoon && (
        <Columns cols={3}>
          {mintingSoon.data.map((project) => (
            <ReviewableCard entity={project} key={project.id} isMintingSoon />
          ))}
        </Columns>
      )}
    </>
  );
}

const Header = styled.header({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  justifyContent: "space-around",
  padding: "0 0 2rem 0",
  "& > *": {
    textAlign: "center",
    width: "100%",
  },
  "@media (min-width: 720px)": {
    flexDirection: "row",
    "& > *": {
      textAlign: "left",
      width: "40%",
    },
  },
});

const Subtitle = styled(Text)(({ theme }) => ({
  ...theme.fonts.display,
  fontSize: theme.fontSizes.xl,
}));

export { MintingSoon };
